/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

/**
 * @param {string} template
 * @param {array} templateKeys
 */
var indexInterpolate = function indexInterpolate(template, templateKeys) {
  var str = template;
  if (!Array.isArray(templateKeys)) {
    return str;
  }
  templateKeys.forEach(function (key, i) {
    str = str.replace(new RegExp("\\{\\{".concat(i, "}}"), 'g'), key);
  });
  return str;
};

export { indexInterpolate };
